import { createGlobalStyle } from 'styled-components';

import { color, font } from './utils';

const GlobalStyle = createGlobalStyle`
  /**
   * CSS reset/normalize adapted from:
   *  - https://andy-bell.co.uk/a-modern-css-reset
   *  - https://tailwindcss.com/docs/preflight
   */

  /* Universal rules */
  *,
  *::before,
  *::after {
    border-style: solid;
    border-width: 0;
    box-sizing: border-box;
  }

  /* Remove default margin */
  body,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  figure,
  blockquote,
  ul,
  ol,
  dl,
  dd {
    margin: 0;
  }

  /* Remove default padding */
  ul, ol {
    padding: 0;
  }

  /* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
  ul[role],
  ol[role] {
    list-style: none;
  }

  /* A elements with underline get some padding between text and line */
  a {
    text-underline-offset: 0.29rem;
  }

  /* A elements that don't have a class get default styles */
  a:not([class]) {
    text-decoration-skip-ink: auto;
  }

  /* Make images easier to work with */
  img,
  svg,
  picture {
    max-width: 100%;
    display: block;
  }

  /* Inherit fonts for form controls and buttons and remove default spacing */
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
    font-weight: inherit;
    line-height: inherit;
    color: inherit;
    margin: 0;
    padding: 0;
  }

  /* Unset font styles on headings */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font: inherit;
  }

  /* Normalize input and select disabled state */
  input:disabled,
  select:disabled {
    background-color: ${color('gray.50')};
    color: ${color('text.muted')};
  }

  /* Fix text transform inheritance */
  button,
  select {
    text-transform: none;
  }

  /* Remove default button styles */
  :where(button, [type='button'], [type='reset'], [type='submit']) {
    -webkit-appearance: button;
    background-color: transparent;
    background-image: none;
    border: none;
  }

  /* Remove all animations, transitions and smooth scroll for people that prefer not to see them */
  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto !important;
    }
    
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  /**
   * Global base styles
   */

  html {
    font-size: 16px;
  }
  
  html:focus-within {
    scroll-behavior: smooth;
  }

  * {
    scroll-padding-block-start: calc(var(--sleuth-safe-area-inset-top, 0px) + 1.5em);
  }

  body {
    color: ${color('text.base')};
    font-family: ${font('base')};
    line-height: 1.5;
    min-height: 100vh;
    text-rendering: optimizeSpeed;
  }

  :where(button, [type='button'], [type='reset'], [type='submit']):not(:disabled) {
    cursor: pointer;
  }
`;

export default GlobalStyle;
